import { useFormState } from 'react-hook-form';
import { useCountryOptionList } from 'src/ui/shared/components/forms/controls/react-selects/CountrySelectControl';
import { Icon } from 'src/ui/shared/components/icon/Icon';
import { CountryLocationControl } from './CountryLocationControl';
import { locationConstants } from './location.constants';
import { LocationButtons } from './LocationButtons';
import { LocationMapWrapper } from './LocationMapWrapper';
import { PeliasLocationControl } from './PeliasLocationControl';
import { LocationInnerFormData } from '../location-form.models';

const { allPeliasFields } = locationConstants;

interface Props {
    id: string;
    isSingle?: boolean;
}

export const LocationFormFields = ({ id, isSingle }: Props): React.ReactElement => {
    const { options } = useCountryOptionList();

    const { errors } = useFormState<LocationInnerFormData>();

    const error = errors[id];

    const errorMessage = allPeliasFields
        .map(field => {
            if (!error) {
                return undefined;
            }
            const fieldError = error[field];

            return fieldError?.message;
        }, [])
        .filter(x => !!x)
        .map(x => x!)
        .join(', ');

    return (
        <div>
            <div className="d-flex w-100">
                <div className="d-grid grid-12 gap-2 flex-grow-1">
                    <div className="p-1 bg-input g-col-4 mb-2 mb-md-0">
                        <LocationMapWrapper id={id} />
                    </div>
                    <div className="g-col-8">
                        <div className="d-lg-grid grid-2 gap-2 mb-2 mb-lg-0">
                            {options && (
                                <CountryLocationControl
                                    id={id}
                                    placeholder="Country"
                                    options={options}
                                    required={isSingle}
                                />
                            )}
                            <PeliasLocationControl id={id} field="region" required={isSingle} />
                            <PeliasLocationControl id={id} field="city" required={isSingle} />
                            <PeliasLocationControl id={id} field="postcode" required={isSingle} />
                            <PeliasLocationControl
                                id={id}
                                field="street"
                                required={isSingle}
                                className="g-col-2"
                            />
                        </div>
                    </div>
                </div>
                {!isSingle && (
                    <div className="ml-2">
                        <LocationButtons id={id} />
                    </div>
                )}
            </div>
            {errorMessage && (
                <Icon
                    className="small text-danger"
                    iconClassName="text-danger"
                    icon="exclamation-triangle"
                >
                    {errorMessage}
                </Icon>
            )}
        </div>
    );
};
